module.exports = __webpack_public_path__ + "static/media/testimonial3.00e21af9.png";